import { render, staticRenderFns } from "./GameContent.vue?vue&type=template&id=28e8c777&scoped=true&"
import script from "./GameContent.vue?vue&type=script&lang=js&"
export * from "./GameContent.vue?vue&type=script&lang=js&"
import style0 from "./GameContent.vue?vue&type=style&index=0&id=28e8c777&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8c777",
  null
  
)

export default component.exports